// Overgezet uit naslag/server/server/generateData/tasksPerCategory/OBS.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
const effects = [
    {
        type: InGameEffect.obs,
        description: 'Ga naar het volgende niveau van OBS',
    },
];
export const OBSTaken = [
    {
        _id: 'obs0',
        type: TaskType.obs,
        title: 'OBS',
        cost: 1000,
        description: 'Zorg dat de werkorders kloppen',
        inGameEffectDescription: 'ga naar het volgende niveau van OBS',
        inGameEffect: [InGameEffect.obs],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'obs1',
        type: TaskType.obs,
        title: 'OBS',
        cost: 1500,
        description: 'Documenteer tekeningen van je assets',
        inGameEffectDescription: 'ga naar het volgende niveau van OBS',
        inGameEffect: [InGameEffect.obs],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'obs2',
        type: TaskType.obs,
        title: 'OBS',
        cost: 1500,
        description: 'Nummer de onderdelen in het magazijn',
        inGameEffectDescription: 'ga naar het volgende niveau van OBS',
        inGameEffect: [InGameEffect.obs],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'obs3',
        type: TaskType.obs,
        title: 'OBS',
        cost: 2000,
        description: 'Zorg voor duidelijke werkinstructies',
        inGameEffectDescription: 'ga naar het volgende niveau van OBS',
        inGameEffect: [InGameEffect.obs],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'obs4',
        type: TaskType.obs,
        title: 'OBS',
        cost: 2000,
        description: 'Geef de monteur een inhoudelijke training over de assets',
        inGameEffectDescription: 'ga naar het volgende niveau van OBS',
        inGameEffect: [InGameEffect.obs],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'obs5',
        type: TaskType.obs,
        title: 'OBS',
        cost: 2000,
        description: 'Zorg voor een service contract',
        inGameEffectDescription: 'ga naar het volgende niveau van OBS',
        inGameEffect: [InGameEffect.obs],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
];
